<div class="landing-bg" aria-hidden="true"></div>
@if (showInstagramBrowserNotice) {
<div class="instagram-notice-backdrop" role="presentation">
  <section
    class="instagram-notice"
    role="dialog"
    aria-modal="true"
    aria-labelledby="landing-instagram-notice-title"
  >
    <button
      class="instagram-notice-close"
      type="button"
      aria-label="Fermer"
      (click)="closeInstagramBrowserNotice()"
    >
      ×
    </button>
    <span class="instagram-notice-icon" aria-hidden="true">↗</span>
    <h2 id="landing-instagram-notice-title">Ouvrir SALOONS hors d’Instagram</h2>
    <p>
      Instagram bloque parfois l’accès à l’App Store. Ouvre le lien dans ton navigateur pour
      télécharger l’application.
    </p>
    <button class="instagram-notice-action" type="button" (click)="openAppStoreOutsideInstagram()">
      Continuer vers l’App Store
    </button>
    <small>
      Si rien ne se passe, touche les <strong>•••</strong> en haut à droite puis
      <strong>Ouvrir dans le navigateur</strong>.
    </small>
  </section>
</div>
}
<div class="landing">
  <app-public-header />

  <!-- HERO -->
  <section class="hero">
    <div class="hero-bg"></div>
    <div class="hero-content">
      <div class="hero-text">
        <div class="hero-kicker">
          <span class="kicker-dot"></span>
          Réseau social local
        </div>
        <h1 class="hero-title">
          Ici, on ne swipe pas.<br /><span class="hero-title-accent">On se rencontre.</span>
        </h1>
        <p class="hero-subtitle">
          SALOONS te connecte aux personnes présentes dans les mêmes lieux que toi&nbsp;: bars,
          événements, campus, salles de sport ou lieux de sortie. Entre dans un saloon, envoie un
          clin d'œil et laisse la vraie rencontre commencer.
        </p>
        <div class="hero-actions">
          <a class="btn-primary" routerLink="/download">Télécharger l'application</a>
          <a class="btn-secondary" href="#how-it-works">Découvrir le concept</a>
        </div>
        <div class="hero-highlights" aria-label="Points forts de SALOONS">
          <span>Local</span>
          <span>Spontané</span>
          <span>Confidentiel</span>
        </div>
      </div>
      <div class="hero-visual">
        <div class="phone-mockup phone-mockup--real">
          <span class="phone-speaker" aria-hidden="true"></span>
          <img
            src="assets/images/app-screens/saloons-nearby.png"
            alt="L'écran Saloons affichant les lieux et personnes à proximité"
          />
        </div>
      </div>
    </div>
  </section>

  <!-- APP PREVIEW -->
  <section class="section app-preview" aria-labelledby="app-preview-title">
    <div class="section-inner preview-inner">
      <div class="preview-copy">
        <p class="section-eyebrow">L'expérience SALOONS</p>
        <h2 class="section-title" id="app-preview-title">
          Tout part d'un lieu.<br />La suite se vit à deux.
        </h2>
        <p class="section-lead">
          Explore les événements autour de toi, remarque les personnes présentes et échange
          uniquement lorsque le clin d'œil est réciproque.
        </p>
        <a class="preview-link" routerLink="/download">Découvrir l'application <span>→</span></a>
      </div>
      <div class="preview-gallery">
        <figure class="preview-phone preview-phone--back">
          <img
            src="assets/images/app-screens/saloons-events.png"
            alt="Les événements proposés dans l'application Saloons"
            loading="lazy"
          />
        </figure>
        <figure class="preview-phone preview-phone--front">
          <img
            src="assets/images/app-screens/saloons-match.png"
            alt="Un clin d'œil réciproque dans l'application Saloons"
            loading="lazy"
          />
        </figure>
      </div>
    </div>
  </section>

  <!-- HOW IT WORKS -->
  <section class="section how-it-works" id="how-it-works">
    <div class="section-inner">
      <h2 class="section-title">Comment ça marche ?</h2>
      <div class="steps-grid">
        <div class="step-card">
          <div class="step-number">1</div>
          <h3>Repère un lieu ou un événement autour de toi</h3>
          <p>Découvre les saloons et les événements disponibles près de ta position.</p>
        </div>
        <div class="step-card">
          <div class="step-number">2</div>
          <h3>Entre dans le saloon</h3>
          <p>Connecte-toi au lieu pendant une durée limitée.</p>
        </div>
        <div class="step-card">
          <div class="step-number">3</div>
          <h3>Envoie un clin d'œil</h3>
          <p>Montre ton intérêt simplement, sans pression.</p>
        </div>
        <div class="step-card">
          <div class="step-number">4</div>
          <h3>Discute si c'est réciproque</h3>
          <p>Quand le clin d'œil est partagé, la conversation peut commencer.</p>
        </div>
      </div>
    </div>
  </section>

  <!-- DIFFERENTIATOR -->
  <section class="section differentiator">
    <div class="section-inner">
      <h2 class="section-title">Pensé pour le réel,<br />pas pour scroller sans fin.</h2>
      <p class="section-lead">
        Rejoins le chat du saloon pour échanger avec les personnes autour de toi, faire connaissance
        et créer des liens amicaux — ou laisser naître un coup de cœur.
      </p>
      <div class="diff-grid">
        <div class="diff-item">
          <span class="diff-icon">🚫</span>
          <span>Pas de swipe infini</span>
        </div>
        <div class="diff-item">
          <span class="diff-icon">📍</span>
          <span>Des rencontres liées à des lieux réels</span>
        </div>
        <div class="diff-item">
          <span class="diff-icon">💬</span>
          <span>Un chat local dans chaque saloon</span>
        </div>
        <div class="diff-item">
          <span class="diff-icon">👋</span>
          <span>Des échanges avec les personnes autour de toi</span>
        </div>
        <div class="diff-item">
          <span class="diff-icon">💛</span>
          <span>Des conversations qui continuent après un coup de cœur confirmé</span>
        </div>
        <div class="diff-item">
          <span class="diff-icon">✨</span>
          <span>Des rencontres amicales ou plus, selon tes envies</span>
        </div>
        <div class="diff-item">
          <span class="diff-icon">🔒</span>
          <span>Respect de la vie privée</span>
        </div>
      </div>
    </div>
  </section>

  <!-- PLACES -->
  <section class="section places">
    <div class="section-inner">
      <h2 class="section-title">Des rencontres là où la vie se passe.</h2>
      <p class="section-lead">
        SALOONS transforme les lieux du quotidien en espaces de rencontre simples, spontanés et
        vivants.
      </p>
      <div class="places-grid">
        <div class="place-badge">🍸 Bars</div>
        <div class="place-badge">🎉 Événements</div>
        <div class="place-badge">🎓 Campus</div>
        <div class="place-badge">💪 Salles de sport</div>
        <div class="place-badge">💻 Coworking</div>
        <div class="place-badge">🌳 Parcs & quais</div>
      </div>
    </div>
  </section>

  <!-- TRUST -->
  <section class="section security" id="security">
    <div class="section-inner">
      <h2 class="section-title">Fais des rencontres en toute confiance.</h2>
      <p class="section-lead">
        Tu gardes le contrôle de ton expérience à chaque instant. SALOONS privilégie des échanges
        simples, respectueux et limités dans le temps pour que tu puisses profiter pleinement de la
        rencontre.
      </p>
      <div class="security-grid">
        <div class="security-item">
          <span class="security-icon">🚨</span>
          <span>Signalement utilisateur</span>
        </div>
        <div class="security-item">
          <span class="security-icon">🛡️</span>
          <span>Modération active</span>
        </div>
        <div class="security-item">
          <span class="security-icon">⏱️</span>
          <span>Expérience limitée dans le temps</span>
        </div>
        <div class="security-item">
          <span class="security-icon">👁️</span>
          <span>Profils et interactions maîtrisés</span>
        </div>
        <div class="security-item">
          <span class="security-icon">🔐</span>
          <span>Respect de la vie privée</span>
        </div>
      </div>
    </div>
  </section>

  <!-- PARTNERS -->
  <section class="section partners" id="partners">
    <div class="section-inner">
      <h2 class="section-title">Vous gérez un bar, un événement ou un lieu de vie ?</h2>
      <p class="section-lead">
        SALOONS peut aider votre lieu à devenir un point de rencontre local, vivant et connecté.
      </p>
      <a class="btn-primary" routerLink="/contact">Nous contacter</a>
    </div>
  </section>

  <!-- CTA FINAL -->
  <section class="section cta-final" id="cta-final">
    <div class="section-inner">
      <div class="cta-card">
        <h2>Prêt à rencontrer autrement ?</h2>
        <p>Rejoins SALOONS et découvre les personnes qui partagent déjà les mêmes lieux que toi.</p>
        <div class="cta-buttons store-cta-buttons">
          <a
            class="store-mini-badge"
            href="https://apps.apple.com/fr/app/saloons/id6758464092"
            rel="noopener"
            (click)="handleAppStoreClick($event)"
          >
            <span aria-hidden="true">
              <svg viewBox="0 0 24 24">
                <path
                  d="M16.35 12.76c-.02-2.42 1.98-3.58 2.07-3.64-1.13-1.66-2.9-1.89-3.52-1.91-1.5-.15-2.93.88-3.69.88-.77 0-1.95-.86-3.2-.84-1.65.02-3.17.96-4.02 2.44-1.71 2.98-.44 7.39 1.23 9.8.82 1.18 1.79 2.5 3.07 2.45 1.23-.05 1.7-.8 3.19-.8 1.49 0 1.91.8 3.21.77 1.33-.03 2.17-1.2 2.98-2.38.94-1.37 1.33-2.7 1.35-2.77-.03-.01-2.64-1.01-2.67-4Zm-2.43-7.14c.68-.82 1.14-1.96 1.01-3.1-.98.04-2.16.65-2.86 1.47-.63.73-1.18 1.9-1.03 3.02 1.09.08 2.2-.56 2.88-1.39Z"
                />
              </svg>
            </span>
            <span><small>Télécharger dans</small><strong>App Store</strong></span>
          </a>
          <a
            class="store-mini-badge"
            href="https://play.google.com/store/apps/details?id=com.saloons.app"
            target="_blank"
            rel="noopener"
          >
            <span aria-hidden="true">
              <svg viewBox="0 0 24 24">
                <path
                  fill="#00a0ff"
                  d="M3.45 2.37 14.53 12 3.45 21.63a2.4 2.4 0 0 1-.2-.98V3.35c0-.34.07-.67.2-.98Z"
                />
                <path
                  fill="#00f076"
                  d="m15.8 10.9 2.78-2.42L5.9 1.35c-.47-.27-.92-.33-1.31-.2L15.8 10.9Z"
                />
                <path
                  fill="#ffce00"
                  d="m15.8 13.1-11.21 9.75c.39.13.84.07 1.31-.2l12.68-7.13-2.78-2.42Z"
                />
                <path
                  fill="#ff3a44"
                  d="M20.41 9.51 17.07 12l3.34 2.49c1.34-.76 1.34-4.22 0-4.98Z"
                />
              </svg>
            </span>
            <span><small>Disponible sur</small><strong>Google Play</strong></span>
          </a>
        </div>
      </div>
    </div>
  </section>

  <!-- FOOTER -->
  <footer class="landing-footer">
    <div class="footer-inner">
      <div class="footer-brand">
        <span class="brand-logo">SAL<span class="brand-oo">OO</span>NS</span>
        <p class="footer-tagline">L'application de rencontre locale pensée pour le réel.</p>
      </div>
      <div class="footer-links">
        <div class="footer-col">
          <h4>Navigation</h4>
          <a href="#how-it-works">Comment ça marche</a>
          <a href="#partners">Partenaires</a>
          <a routerLink="/download">Télécharger</a>
        </div>
        <div class="footer-col">
          <h4>Légal</h4>
          <a routerLink="/cgu">CGU</a>
          <a routerLink="/politique-confidentialite">Politique de confidentialité</a>
          <a routerLink="/mentions-legales">Mentions légales</a>
          <a routerLink="/suppression-compte">Suppression de compte</a>
          <a routerLink="/protection-des-mineurs">Protection des mineurs</a>
        </div>
      </div>
      <div class="footer-bottom">
        <p>© {{ currentYear }} SALOONS — Tous droits réservés.</p>
        <p class="footer-disclaimer">
          SALOONS n'est pas affilié aux établissements, événements ou lieux affichés, sauf mention
          contraire explicite.
        </p>
      </div>
    </div>
  </footer>
</div>
